import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import DocumentMeta from 'react-document-meta';
import * as authActions from 'redux/modules/auth';
import {getWindowSize} from '../../utils/utils';
import immutable from 'immutable';
import {RxForm, Checkbox, FormField} from 'reactis-forms';
import {TextInput} from 'reactis-inputs';

@connect(
	state => ({user: state.auth.user}),
	authActions)
export default class Login extends Component {

	static contextTypes= {
		router: React.PropTypes.object,
		user: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);
		this.state = {
			error: false
		}
		this.schema = {
			username: {
				class: TextInput,
				autoFocus: 300,
				label: 'Login',
				type: 'email',
				placeholder: 'Zadejte e-mail',
				className: 'form-control',
				rules: {
					presence: {message: 'Zadejte email!'}
				}
			}
		};
	}

	handleSubmit(form) {
		const values = form.getValues().toJS();
		this.props.resetPassword(values.username).then((result) => {
			if (!result.error || result.error.code == 404) {
				this.props.onLogin({msg: 'Na váš e-mail byly odeslány instrukce pro obnovení hesla.'});
			}
			else {
				//console.log(result.error);
			}
		});
	}

	handleBack(e) {
		e.preventDefault();
		this.props.onLogin();
	}

	render() {

		return (
			<div className="">
			<RxForm ref="form" id="lostpassword" schema={this.schema} className="form-login" onSubmit={this.handleSubmit.bind(this)}>
				<div className="text-center">
					<h5 className="content-group">Zapomenuté heslo do systému
						<small className="display-block">Zadejte váš e-mail.</small>
					</h5>
				</div>
				<br/>
				{this.state.error && <div className="errorHandler alert alert-danger">
					{this.state.error}
				</div>}
				<div className="form-group has-feedback has-feedback-left">
						<FormField name="username"/>
						<div className="form-control-feedback">
							<i className="icon-user text-muted"></i>
						</div>
				</div>
				<div className="form-group">
					<button type="submit" className="btn bg-blue btn-block">Odeslat <i className="icon-arrow-right14 position-right"></i></button>
				</div>
				<br/>
				<br/>
				<div className="text-right">
					<a href="/login" onClick={(e) => this.handleBack(e)}>&lt; zpět na přihlášení</a>
				</div>
			</RxForm>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Login/LostPassword.js